/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} That_Wild_Dachshund_AbsorbInputs */

const fr_that_wild_dachshund_absorb = /** @type {(inputs: That_Wild_Dachshund_AbsorbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carré`)
};

/**

* @param {That_Wild_Dachshund_AbsorbInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const that_wild_dachshund_absorb = /** @type {((inputs?: That_Wild_Dachshund_AbsorbInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<That_Wild_Dachshund_AbsorbInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_that_wild_dachshund_absorb(inputs)
});